/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAllRolesAndPermissionsResponse } from '../../models/get-all-roles-and-permissions-response';

export interface GetPermissionsByAppId$Params {
  applicationId: string;
}

export function getPermissionsByAppId(http: HttpClient, rootUrl: string, params: GetPermissionsByAppId$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllRolesAndPermissionsResponse>> {
  const rb = new RequestBuilder(rootUrl, getPermissionsByAppId.PATH, 'get');
  if (params) {
    rb.path('applicationId', params.applicationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAllRolesAndPermissionsResponse>;
    })
  );
}

getPermissionsByAppId.PATH = '/api/v2/{applicationId}';
